import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <main className="about-page">
      <h1>Page not found</h1>
      <p>That route does not match a book or page on LoreBites.</p>
      <p>
        <Link to="/">Back to books</Link>
      </p>
    </main>
  );
}

export default NotFound;
